import POIStep from "@/components/POI/POIStep/POIStep.vue";

export default {
  components: { POIStep },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  created() {
    if (!Array.isArray(this.editedItem.highlights)) {
      this.$set(this.editedItem, "highlights", ["", "", ""]);
    }
    while (this.editedItem.highlights.length < 3) {
      this.editedItem.highlights.push("");
    }
  },
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    updateHighlight(index, val) {
      this.$set(this.editedItem.highlights, index, val);
    }
  }
};
